<template>
  <div class="container-fluid">

    <div class="row"></div>

    <div class="row">

      <div class="col s9">
        <div class="col s12 z-depth-1 white">
          <div class="section">
            <h5>Earthfaults</h5>
          </div>
          <highcharts :options="chartOptions" />
        </div>
      </div>

      <div class="col s3">
        <div class="col s12 z-depth-1 white" style="height: 300px;">
          <h5>Filter</h5>
          <div class="input-field">
            <date-picker @input="dateChanged" v-model="date" :max-date="maxDateByMeasurement" @dateChanged="datePickerChanged" style="padding-right: 6px;" />
            <period-selector v-model="selectedPeriod" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EarthFaultService from '@/services/EarthFaultService'
import {Chart} from 'highcharts-vue'
import moment from 'moment'
import DatePicker from '@/components/switch/DatePicker'
import PeriodSelector from '@/components/PeriodSelector'
import Highcharts from 'highcharts'

export default {
  components: {
    HighChart: Chart,
    'datePicker': DatePicker,
    PeriodSelector
  },
  computed: {
    maxDateByMeasurement () {
      if (this.selectedAsset && this.selectedAsset.MeasurementSet.TriggeredMeasurements[0]) {
        return moment(this.selectedAsset.MeasurementSet.TriggeredMeasurements[this.selectedAsset.MeasurementSet.TriggeredMeasurements.length - 1].MeasurementDateTime).toDate()
      } else {
        return new Date()
      }
    }
  },
  props: {
    complexObject: {
      type: Object,
      required: true
    },
    selectedAsset: {
      type: Object,
      default: () => {
      }
    },
    railObject: {
      type: Object,
      default: () => {
      }
    },
    childObjects: {
      required: false,
      type: Array,
      default: () => []
    }
  },
  created: function () {
    this.setLastMeasurementDate()
  },
  data () {
    return {
      r8assets: undefined,
      componentId: undefined,
      inputDate: '-24',
      date: {
        start: moment().subtract(1, 'w'),
        end: moment()
      },
      selectedPeriod: '1week',
      chartOptions: {
        chart: {
          zoomType: 'x',
          resetZoomButton: {
            position: {
              x: 0,
              y: -10
            }
          },
          animation: false,
          zooming: {
            mouseWheel: {
              enabled: true
            }
          },
          events: {
            load () {
              const chart = this

              // Block scroll wheel unless Shift is held
              chart._wheelBlocker = (e) => {
                if (!e.shiftKey) {
                  if (e.stopImmediatePropagation) e.stopImmediatePropagation()
                  e.stopPropagation()
                }
              }
              chart.container.addEventListener('wheel', chart._wheelBlocker, { capture: true })

              // Show zoom cursor when Shift is held
              chart._cursorHint = (e) => {
                chart.container.style.cursor = e.shiftKey ? 'zoom-in' : ''
              }
              chart.container.addEventListener('mousemove', chart._cursorHint)

              // Flip cursor immediately on Shift press/release
              chart._onKeyShift = (e) => {
                if (e.key === 'Shift' && chart.container) {
                  chart.container.style.cursor = (e.type === 'keydown') ? 'zoom-in' : ''
                }
              }
              chart._offKeyDown = Highcharts.addEvent(document, 'keydown', chart._onKeyShift)
              chart._offKeyUp = Highcharts.addEvent(document, 'keyup', chart._onKeyShift)
            },
            destroy () {
              const el = this.container
              if (this._wheelBlocker && el) el.removeEventListener('wheel', this._wheelBlocker, { capture: true })
              if (this._cursorHint && el) el.removeEventListener('mousemove', this._cursorHint)
              if (this._offKeyDown) this._offKeyDown()
              if (this._offKeyUp) this._offKeyUp()
            }
          }
        },
        title: false,
        plotOptions: {
          line: {
            step: 'left',
            marker: {
              enable: true
            }
          }
        },
        accessibility: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        tooltip: {
          formatter: function () {
            // in database in UTC. Need local here
            return moment(this.x).format('YYYY-MM-DD HH:mm:ss') + '<br/>' +
              '<b>' + this.y + '</b>'
          },
          shared: true
        },
        yAxis: {
          title: false,
          tickInterval: 1,
          min: 0,
          max: 2
        },
        xAxis: {
          title: {
            enabled: false
          },
          type: 'datetime',
          gridLineWidth: 1,
          labels: {
            formatter: function () {
              return moment(this.x).format('YYYY-MM-DD') // in database in UTC. Need local here
            }
          }
        },
        series: [
          { name: 'Earthfault',
            data: undefined }
        ]
      }
    }
  },
  watch: {
    '$route.params.id': async function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.dateChanged()
      }
    },
    selectedPeriod (period) {
      if (period === 'user_input') {
        return
      }
      const end = moment().startOf('day').format()
      const start = this.getStartDate(end)
      this.date = {
        start,
        end
      }
    }
  },
  mounted: async function () {
    M.FormSelect.init(document.querySelectorAll('select'))
    this.dateChanged()
  },
  methods: {
    setLastMeasurementDate () {
      if (this.selectedAsset) {
        const triggeredMeasurements = this.selectedAsset.MeasurementSet.TriggeredMeasurements
        const length = triggeredMeasurements.length
        if (length > 0) {
          const end = moment(triggeredMeasurements[length - 1].MeasurementDateTime)
          const start = moment(end).subtract(1, 'w')
          this.date = {
            start,
            end
          }
        }
      }
    },
    setAssetComponentId: async function () {
      var asset = await this.r8assets.find(r => r.uniqueId === this.railObject.UniqueId)
      if (asset && asset.children) {
        this.componentId = asset.children[0].name
      }
    },
    dateChanged: function () {
      var start = moment(this.date.start).startOf('day').utc().format() // todays date
      var end = moment(this.date.end).endOf('day').utc().format() // another date
      this.getEarthFaultData(start, end)
    },
    getEarthFaultData: async function (start, end) {
      if (this.railObject !== undefined) {
        // await EarthFaultService.GetEarthFaultAsync(this.railObject.UniqueId, this.selectedAsset.UniqueId, this.selectedAsset.EventCode, start + '-til-' + end).then(result => {
        // this.selectedAsset.EventCode comes from switch and this is ComplexData, hardcoded EARTFAULT..
        await EarthFaultService.GetEarthFaultAsync(this.railObject.UniqueId, this.selectedAsset.UniqueId, 'EARTHFAULT', start + '-til-' + end).then(result => {
          if (result && result.data && result.data.length > 0) {
            this.chartOptions.series[0].data = this.createSeriesData(result.data)
          }
        })
      }
    },
    createSeriesData: function (data) {
      var formattedData = []
      data.forEach(element => {
        formattedData.push([moment(element.dt).valueOf(), element.val === 'True' ? 1 : 0])
      })
      return formattedData
    },
    formatDateTime: (dateTime) => {
      return moment(String(dateTime)).format('YYYY-MM-DD HH:mm:ss')
    },
    datePickerChanged () {
      this.selectedPeriod = 'user_input'
    },
    getStartDate (endDate) {
      switch (this.selectedPeriod) {
        case '1week':
          return moment(endDate).subtract(1, 'weeks')
        case '2weeks':
          return moment(endDate).subtract(2, 'weeks')
        case '1month':
          return moment(endDate).subtract(1, 'months')
        case '3months':
          return moment(endDate).subtract(3, 'months')
        case '6months':
          return moment(endDate).subtract(6, 'months')
        case '1year':
          return moment(endDate).subtract(1, 'years')
        default:
          return moment(endDate).subtract(1, 'months')
      }
    }
  }
}
</script>

<style scoped>
.occupied-spacing-right {
  margin-right: 12px
}

.popover-container {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/pages/switch/_earthfault/EarthFault.vue